import React, { useState, useEffect } from 'react';


// App Components:
import Carousal from "../../components/UI Components/CustomCarousal/Carousal";

// MUI Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';

// React Icons:
import { IconContext } from "react-icons"
import { BiShekel, BiMapPin, BiHome, BiArrowBack } from "react-icons/bi";
import { IoCloseSharp, IoChatboxEllipsesOutline  } from "react-icons/io5";
import { MdFavoriteBorder } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { AiOutlinePhone, AiOutlineShareAlt  } from "react-icons/ai";


// Styled comp:
import { styled } from '@mui/material/styles';

// Theme
import { useTheme } from '@mui/material/styles';

// translation:
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';

// model
import { _getObject } from '../../models/model';

// custom Hooks
import useScreenSize from '../../custonHooks/useScreenSize';


function ObjDetailView({handleDlgClose, currObjId}) {

  const { t, i18n }  = useTranslation(),
        theme        = useTheme(),
        screenSize   = useScreenSize();


 /*************************************************************
  * Style Definiton for Component
  ************************************************************/

 
   const SectionTitle   =  styled(Typography) ({ 
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        fontWeight:'bold'

   });
   const SectionDivider =  styled(Divider) ({ 
        padding:'0.5rem'
   });
   const SectionItem    =  styled(Box) ({   });

    const ImageGallery =  styled(Box) ({ 
        // position:'sticky',
        // top:0

    });

    const ObjectPrice    = styled(Box) ({
        display:'flex',
        alignItems:'center'
     });
    const ObjectLocation = styled(Box) ({ 
        display:'flex',
        alignItems:'center'
    });

    const ObjectTitleContainer =  styled(Box) ({
        display: 'flex',
        flexDirection:'column',
        [`& ${ObjectPrice}`]    : ({ }),
        [`& ${ObjectLocation}`] : ({ }),
        [`& ${SectionItem}`] : ({ }),
        

    });

    const ObjectInfoContainer =  styled(Box) ({
        marginLeft: '1rem',
        marginRight: '1rem',
        // marginBottom: '5rem',

        [`& ${SectionTitle}`] :({

        })
    });

    const ObjectDescrContainer = styled(Box) ({
        marginLeft: '1rem',
        marginRight: '1rem',
        marginBottom: '5rem',

        [`& ${SectionTitle}`] :({

        })
    });

    const ObjectFooter =  styled(Box) ({
        position:'sticky',
        bottom:0,
        display:'flex',
        justifyContent:'space-around',
        height:'3rem',
        width:'100%',
        backgroundColor:'#fff',
        borderTop:'1px groove'



    });

    const oIconConext = {
            objPrice: {
                 style: { fontSize: '25px', color: "gray" } 
            },
            objLocation: {
                style: { fontSize: '25px', color: "gray" } 
            },
            favIcon: {
                style: { 
                        fontSize: '25px',
                        color: "gray",
                        marginLeft:'1rem'
                    } 
            }

    }


    const ObjectDetailContainer =  styled(Box) ({
            textAlign:'right',
            color:'gray',
       [`& ${ObjectInfoContainer}`] :({

        }),
      [`& ${ObjectFooter}`] :({

        })

    });

   /******************************************************
    * Event handling
    ******************************************************/

    const [object, setObjectDetail] = useState([]);
    const [objectCity, setObjectCity] = useState('')
    const [contactInfo, setContactInfo] = useState([]);
    const [objectImages, setObjectImages] = useState([]);
    const [vImgHeight,setImageHeight] = useState(300);

    const [objectImagesSmall, setObjectImagesSmall] = useState([]);
    const [objectImagesMedium, setObjectImagesMedium] = useState([]);
    const [objectImagesLarge, setObjectImagesLarge] = useState([]);


    useEffect(() => {
        let objectID  = currObjId;
            // mediaSize = screenSize.isMobile ? 'small' : screenSize.isTablet ? 'medium' : 'large';



        if(objectID) {
            getObjectDetails(objectID);
        }
        
    }, [currObjId])

       async function getObjectDetails(objectID) {

        let srvResp,
            resJSON,
            data,
            objectCity,
            oContact,
            aContact,
            vIsMobile,
            vIsTablet,
            vIsDesktop,
            mediaSize;
            // mediaSize = screenSize.isMobile ? 'small' : screenSize.isTablet ? 'medium' : 'large';

        // determine screen size:
            vIsMobile  = window.innerWidth <= 768 ? true : false;
            vIsTablet  = window.innerWidth > 768 && window.innerWidth <= 900 ? true : false ;
            vIsDesktop = window.innerWidth > 900;

            mediaSize = vIsMobile? 's' : vIsTablet ? 'm' : 'l';


        // srvResp = await fetch('/rentals/object', { 
        //     method : 'POST',
        //     body   : JSON.stringify({ objectID }),
        //     headers: { 'Content-Type': 'application/json' }
        // });

        // srvResp = await fetch(`/rentals/${objectID}`);

        // resJSON = await srvResp.json();
        // data    = await resJSON;

        console.log(mediaSize, "from obj detail");

        data = await _getObject(objectID,mediaSize);

        setObjectDetail(data);

        objectCity = data.city_name

        oContact = data.contact;
        aContact = [oContact.contactName, oContact.phone, oContact.email];

        setContactInfo(aContact);

        //code to be modified. one single state object for all fields

        switch(mediaSize) {

            case 's':
                setObjectImages(data.mediaSmall);
                setImageHeight(300);
            break;

            case 'm':
                setObjectImages(data.mediaMedium);
                 setImageHeight(700);
            break;

            case 'l':
                setObjectImages(data.mediaLarge);
                 setImageHeight(700);
            break;

            default://
        }
        
        
        

        // props.updateBusyState(false);
    }

    const handleFavoriteClick = () => {

    }

    return(
        <>
        <ObjectDetailContainer>
            
            <ImageGallery>
                <Carousal currObjID={currObjId} currObjcetImages={objectImages} sImageHight={vImgHeight}/> 
            </ImageGallery>

            <SectionDivider/>

            <Grid container spacing={1}>
                <Grid size={6}>
                   <SectionItem>
                        <ObjectPrice>
                            <IconContext.Provider value={oIconConext.objPrice}>
                                <BiShekel />
                            </IconContext.Provider> {object.price} ({t('object.objectInfo.timeMeasure')})
                        </ObjectPrice>

                        <ObjectLocation>
                            <IconContext.Provider value={oIconConext.objPrice}>
                                <BiMapPin />
                            </IconContext.Provider> {object.city_name} - {object.area}
                        </ObjectLocation>

                   </SectionItem>
                </Grid>
                <Grid size={6} sx={{display:'flex', alignItems:'center', justifyContent:'end'}}>
                    <SectionItem>
                        <IconContext.Provider value={oIconConext.favIcon}>
                            <MdFavoriteBorder onClick={handleFavoriteClick} />
                        </IconContext.Provider>
                    </SectionItem>


                    <SectionItem  href="https://api.whatsapp.com/send?phone=972559969449">
                        <IconContext.Provider value={oIconConext.favIcon}>
                            <AiOutlineShareAlt href="https://api.whatsapp.com/send?phone=972559969449"/>
                        </IconContext.Provider>
                    </SectionItem>
                    
                </Grid>
            </Grid>

            

            {/* <ObjectTitleContainer>
                    <ObjectPrice>
                        <IconContext.Provider value={{ style: { fontSize: '25px', color: "gray" } }}>
                            <BiShekel />
                        </IconContext.Provider> {object.price} ({t('object.objectInfo.timeMeasure')})
                    </ObjectPrice>

                    <ObjectLocation>
                        <IconContext.Provider value={{ style: { fontSize: '25px', color: "gray" } }}>
                            <BiMapPin />
                        </IconContext.Provider> {objectCity} - {object.area}
                    </ObjectLocation>

                    

            </ObjectTitleContainer> */}

            <SectionDivider />

            <ObjectInfoContainer>

                <SectionTitle variant='h6'>
                    {t('objectDetail.sectionTitle.properties')}  
                </SectionTitle>

                <SectionItem>
                   {t('objectDetail.properties.objSubType')}
                   {object.objectSubType}
                </SectionItem>

                <SectionItem>
                   {t('objectDetail.properties.livingSpace')}
                   {object.livingSpace} متر مربع
                </SectionItem>

                <SectionItem>
                   {t('objectDetail.properties.numberOfRooms')}
                   {object.numberOfRooms}
                </SectionItem>

                <SectionItem>
                   {t('objectDetail.properties.numberOfBathrooms')}
                   {object.numberOfBathrooms}
                </SectionItem>

                <SectionItem>
                   {t('objectDetail.properties.balkonAvailable')}
                   {object.balkonAvailable}
                </SectionItem>
                <SectionItem>
                   {t('objectDetail.properties.numberOfFloors')}
                   {object.numberOfFloors}
                </SectionItem>
                <SectionItem>
                   {t('objectDetail.properties.elevatorAvailable')}
                   {object.elevatorAvailable}
                </SectionItem>
            </ObjectInfoContainer>

            <SectionDivider />

            <ObjectDescrContainer>
                <SectionTitle variant='h6'>
                    {t('objectDetail.sectionTitle.general')} 
                </SectionTitle>

                <SectionItem>
                    {t('objectDetail.sectionTitle.properties')}
                    <span>تختلف الغرف السكنيّة في الكليات والجامعات في الحجم والشكل والمرافق وعدد الأشخاص. في الولايات المتحدة تتسع كل غرفة من غرف السكن الجامعي الإقامة اثنين من الطلاب مع عدم وجود المرحاض. وعادة ما يشار إلى هذا النوع من الغرف بالغرف "المزدوجة". في كثير من الأحيان، قاعات السكن لها مرافق حمام مشتركة.</span>                   
                </SectionItem>

            </ObjectDescrContainer>


            <ObjectFooter>
                <IconButton size='large'href="tel:+972559969449">
                    <AiOutlinePhone/>
                </IconButton>
                <IconButton size='large' href="https://api.whatsapp.com/send?phone=972559969449">
                    <IoChatboxEllipsesOutline />
                </IconButton>
            </ObjectFooter>


        </ObjectDetailContainer>

        </>
    );
}

export default ObjDetailView;

